module.exports = __webpack_public_path__ + "media/images/illustrations/wave-starworks-2-5d63f9f43c4c457a85a980be7e99614b.svg";